<template>
  <div class="habit-form-wrapper">
    <div v-if="isActiveModal" class="habit-form-wrapper__modal-wrapper">
      <h2 class="habit-form-wrapper__modal-wrapper--title">
        {{ $t(`${translationPath}.addNew`) }}
      </h2>
      <b-field class="mt-4" :label="$t('habitName')" >
        <b-input type="textarea" v-model="habitName"></b-input>
      </b-field>

      <b-field class="mt-4" label="How many times a day to pass?" >
        <b-input placeholder="Number"
            v-model="number"
            type="number"
            @blur="onBlurNumberInput"
          >
          </b-input>
          <p style="color: red;" v-if="!number">Muszisz podać minimalną liczbę do zaliczenia</p>
      </b-field>

      <b-field class="mt-4" :label="$t(`${translationPath}.pickTimeLabel`)">
          <b-timepicker
              v-model="time"
              rounded
              :placeholder="$t(`${translationPath}.clickToSelect`)"
              icon="clock"
              hour-format="24"
              editable
              :enable-seconds="false">
          </b-timepicker>
      </b-field>
<!-- TODO  add edit, add calculations and showing system -->
      <section class="mt-4" v-if="false">
        <b-checkbox style="margin: 5px;" size="is-medium" v-model="isSpecyficDays">
          Select days to check (suport soon)
          </b-checkbox>
        <div
          style="display: flex;
          flex-direction: column; height: 100px; flex-wrap: wrap;"
          v-if="isSpecyficDays"
        >
          <b-checkbox style="margin: 5px;" size="is-medium" v-model="checkedDays"
              native-value="Mon">
              Mon
          </b-checkbox>
          <b-checkbox style="margin: 5px;" size="is-medium" v-model="checkedDays"
              native-value="Tue">
              Tue
          </b-checkbox>
          <b-checkbox style="margin: 5px;" size="is-medium" v-model="checkedDays"
              native-value="Wed">
              Wed
          </b-checkbox>
          <b-checkbox style="margin: 5px;" size="is-medium" v-model="checkedDays"
              native-value="Thu">
              Thu
          </b-checkbox>
          <b-checkbox style="margin: 5px;" size="is-medium" v-model="checkedDays"
              native-value="Fri">
              Fri
          </b-checkbox>
          <b-checkbox style="margin: 5px;" size="is-medium" v-model="checkedDays"
              native-value="Sat">
              Sat
          </b-checkbox>
          <b-checkbox style="margin: 5px;" size="is-medium" v-model="checkedDays"
              native-value="Sun">
              Sun
          </b-checkbox>
        </div>
      </section>

      <div class="buttons mt-4">
        <b-button type="is-primary" expanded :disabled="!this.number || habitName.length < 5"
          @click="addActivityHabitsEvent">{{ $t(`${translationPath}.addHabit`) }}</b-button>
        <b-button type="is-primary is-light"
          expanded @click="makeModalUnActive(false);">
          {{ $t(`${translationPath}.closeModal`) }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    addActivityHabits: Function,
    makeModalUnActive: Function,
    isActiveModal: Boolean,
    habitForThisDay: Array,
    isButton: Boolean,
  },
  data() {
    return {
      habitName: '',
      time: this.$moment().seconds(0).milliseconds(0).toDate(),
      translationPath: 'habit',
      link: '',
      number: 1,
      checkedDays: [],
      isSpecyficDays: false,
    };
  },
  methods: {
    onBlurNumberInput() {
      if (!this.number) return;
      const isString = typeof this.number === 'string' || this.number instanceof String;
      if (isString) this.number = this.number.replace('e', '');
      this.number = parseInt(this.number, 10);
    },
    ...mapActions({
      setNotification: 'applicationStore/setNotification',
    }),
    async addActivityHabitsEvent() {
      const isExist = this.habitForThisDay.some((habit) => habit.name === this.habitName);
      const isLink = this.link.includes('https') || this.link.includes('http') || this.link.includes('www.');
      if (isExist) {
        this.$buefy.notification.open({
          message: this.$t(`${this.translationPath}.IsAlreadyExist`),
          type: 'is-danger',
          position: 'is-top',
        });
        return;
      }
      if (this.habitName.length < 1) return;
      if (!(this.link.length === 0) && !isLink) return;

      const habitToCreated = {
        localId: this.$uniqueId(),
        name: this.habitName,
        created: this.$moment().toISOString(),
        isActive: true,
        time: this.$moment(this.time).format('HHmm'),
        link: this.link,
        valueToDone: this.number,
      };
      if (this.checkedDays.length > 0) habitToCreated.habitDays = this.checkedDays;

      const item = await this.addActivityHabits(habitToCreated);
      this.link = '';
      this.number = 1;
      this.habitName = '';
      this.makeModalUnActive(false);
      this.setNotification({
        header: `${this.$t('habitModalAlertHeader')}: "${item.name}".`,
        message: this.$t('habitModalAlertContent'),
      });
    },
    parentEvent(status) {
      this.makeModalUnActive(status);
    },
  },
};
</script>

<style scoped lang="scss">
.habit-form-wrapper {
  &__button-wrapper{
    position: fixed;
    bottom: 28px;
    left:0;
    z-index: 1;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__add-button {
    font-size: 15px;
    font-weight: 700;
    background: $background-brand-color;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    color: $font-light-color;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__modal-wrapper {
    overflow-y: auto;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 20px;
    backdrop-filter: blur(16px) saturate(180%);
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    background-color: $background-light-color;

    &--title {
      text-align: center;
      font-size: 25px;
      font-weight: 700;
      margin: 30px;
    }
  }
}
</style>
